import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Icon } from '@innovamat/glimmer-components';

const Action = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  min-width: 40px;
  width: fit-content;
  height: 40px;
  background-color: ${({ theme }) =>
    theme.tokens.color.global.neutral.neutral100.value};
`;

const Wrapper = styled(Action)<{ isOpen: boolean }>`
  svg path {
    fill: ${({ theme }) => theme.tokens.color.global.neutral.neutral700.value};
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: rotate(180deg);
    `};
`;

type ArrowActionButtonProps = {
  isOpen: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

function ArrowActionButton({
  isOpen,
  ...rest
}: ArrowActionButtonProps): JSX.Element {
  return (
    <Wrapper {...rest} isOpen={isOpen}>
      <Icon icon="ExpandMoreIcon" />
    </Wrapper>
  );
}

export { ArrowActionButton };
export type { ArrowActionButtonProps };
